// src/routes/auth/login-callback.tsx
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Stack, Loader, Text, Card, Image, Button } from '@mantine/core';
import { useOktaAuth } from '../../providers/okta-auth-provider';

export function LoginCallback() {
  const { handleLoginRedirect, login } = useOktaAuth();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    // Il callback OAuth si può completare una sola volta
    if (started.current) return;
    started.current = true;

    handleLoginRedirect()
      .then(() => {
        // Recupera l'URL originale o vai alla dashboard
        const originalUri = sessionStorage.getItem('originalUri') || '/';
        sessionStorage.removeItem('originalUri');
        navigate({ to: originalUri });
      })
      .catch((error) => {
        console.error('Login callback error:', error);
        setFailed(true);
      });
  }, [handleLoginRedirect, navigate]);

  return (
    <Stack align="center" justify="center" style={{ minHeight: '100vh' }}>
      <Card shadow="md" padding="xl" radius="md" style={{ width: '100%', maxWidth: 400 }}>
        <Stack align="center" gap="md">
          <Image
            src="/logo.png"
            height={60}
            fit="contain"
            alt="Logo"
          />
          {failed ? (
            <>
              <Text size="lg" fw={500} c="red">
                Errore di autenticazione
              </Text>
              <Text size="sm" c="dimmed" ta="center">
                Non è stato possibile completare l'accesso.
              </Text>
              <Button onClick={() => login()} fullWidth>
                Riprova
              </Button>
            </>
          ) : (
            <>
              <Text size="lg" fw={500}>
                Completamento login...
              </Text>
              <Loader size="md" />
            </>
          )}
        </Stack>
      </Card>
    </Stack>
  );
}
